<!-- שדה חיפוש -->
<!-- in order to add an icon inside the input, remove the style of the input and put it on the wrapper div -->
<form>
    <div class="input-group rounded" [ngClass]="focus?'focused':''">
        <!--the class 'focused' is styled in the styles.scss file-->
<!---->
        <!-- <input (input)="getOffers()"   list="datalistOptions" type="search" value="teal"  (focus)="focus=true" -->
        <input    list="datalistOptions" type="search" value="teal"  (focus)="focus=true"
            (blur)="focus=false" class="form-control rounded" placeholder="חיפוש" aria-label="Search"
            aria-describedby="search-addon" name="search" [(ngModel)]="searchText" (keydown)="IfEnterSearch($event)">

        <!--בהקשת אנטר או בלחיצה על האייקון מתצע החיפוש-->
        <mat-icon class="icon" id="search-icon" matPrefix (click)="search()">search</mat-icon>

    </div>
    <datalist id="datalistOptions">
        <option *ngFor="let o of offers  | slice:0:100; let i=index" value={{o.title}}>
        <!-- <option *ngFor="let o of offers ; let i=index" value={{o.title}}> -->
        <!-- <option *ngFor="let o of offers; let i=index" value={{o.title}}> -->
    </datalist>
    <!-- <div id="offers">
        <span >{{o.title}}</span>
    </div> -->
</form>